import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';

import {
  CurrencyComponent,
  getColumnKey,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { isNotNil } from '@web/utils';
import {
  PublicSubscriptionCollectionFilter,
  PublicSubscriptionCollectionItem,
  SubscriptionStatusComponent,
} from '@web/shared/module/shop';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-public-subscription-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    CurrencyComponent,
    SubscriptionStatusComponent,
    RouterLinkComponent,
    Tooltip,
  ],
  templateUrl: './public-subscription-list-custom-cell-template.component.html',
  styleUrl: './public-subscription-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicSubscriptionListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<PublicSubscriptionCollectionItem, PublicSubscriptionCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<PublicSubscriptionCollectionItem>();

  /* prettier-ignore */
  public readonly detailsParams = this.detailsParamsSignal();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<PublicSubscriptionCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly Route = Route;

  private detailsParamsSignal(): Signal<RouterLinkParams> {
    return computed(() => {
      return {
        [RouteParam.Number]: this.model().number,
      };
    });
  }
}
